import { render } from "./manage.vue?vue&type=template&id=8a4d79ee&scoped=true&ts=true"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=8a4d79ee&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a4d79ee"]])

export default __exports__